import { render, staticRenderFns } from "./delete-modal.vue?vue&type=template&id=11328f29&"
import script from "./delete-modal.vue?vue&type=script&lang=js&"
export * from "./delete-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports